import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { Container } from "../components/Container";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
const apiUrl = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Perform the data fetching operation
    axios
      .get(`${apiUrl}/api/v1/getnews`)
      .then((response) => {
        const fetchedData = response.data.data || [];

        // Sort the data in descending order based on date
        const sortedData = fetchedData.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setData(sortedData); // Update the state with sorted data
      })
      .catch((err) => {
        // Handle errors
        console.log(err); // For debugging purposes
      });
  }, []);

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return {
      date: date.toLocaleDateString(),
    };
  };

  return (
    <>
      <Container>
        {/* */}
        <div className="  bg-[#754C28] grid grid-cols-4 p-[10px] gap-[2%] md:gap-0  md:grid-cols-1 h-auto md:py-[20px] font-poppins">
          <div className="py-[20px]">
            <h5 className="font-semibold text-white">Quick Links</h5>
            <nav className="grid grid-cols-1 text-white space-y-[10px] ">
              <NavLink
                to="/executive"
                className="no-underline text-white border-b-[1px] border-[#3e3d3c]  hover:text-[18px] hover:duration-1000 duration-1000"
              >
                Executive Committee{" "}
              </NavLink>
              <NavLink
                to="/history"
                className="no-underline text-white border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000"
              >
                Rate History
              </NavLink>
              <NavLink
                to="/graph"
                className="no-underline text-white border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000"
              >
                Rate Graph{" "}
              </NavLink>
              <NavLink
                to="/news"
                className="no-underline v text-white border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000"
              >
                Latest News{" "}
              </NavLink>
              <NavLink
                to="/notices"
                className="no-underline text-white border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000"
              >
                Notices
              </NavLink>
            </nav>
          </div>
          <div>
            <div className="py-[20px]">
              <h5 className="font-semibold text-white w-full">Weekly news</h5>
              <nav className="grid grid-cols-1 text-white space-y-[12px] ">
                {data.slice(0, 6).map((news) => {
                  const { date } = formatDateTime(news.date);
                  return (
                    <NavLink
                      key={news.id}
                      to={news.linkUrl}
                      className="no-underline text-white border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000 flex items-center gap-[8px]"
                    >
                      Weekly Report <FaRegCalendarAlt /> {date}
                    </NavLink>
                  );
                })}
              </nav>
            </div>
          </div>

          <div className="md:pb-[-10px] text-white">
            <div>
              <h5 className="font-semibold ">Contact Information</h5>
            </div>

            <p className="flex items-center gap-x-[5px] border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000 w-full cursor-pointer">
              <FaMapMarkerAlt /> Block No-17, Kathmandu{" "}
            </p>

            <p className="flex items-center gap-x-[5px] border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000 w-full cursor-pointer">
              {" "}
              <IoIosMail /> info@kagosida.org.np
            </p>

            <p className="flex items-center gap-x-[5px] border-b-[1px] border-[#3e3d3c] hover:text-[18px] hover:duration-1000 duration-1000 w-full cursor-pointer">
              <FaPhoneAlt />
              5369730, 5319293
            </p>

            <div className="mb-[10px]">
              <p className="underline">Follow Us On:</p>
              <div className="flex items-center gap-x-[12px] mt-[-6px]">
                <a
                  href="https://www.facebook.com/kagosida.kagosida?mibextid=LQQJ4d"
                  className="border-[7px] border-[#381b69] rounded-[50%] cursor-pointer hover:translate-y-[-5px]"
                >
                  {" "}
                  <FaFacebook className="text-[17px] text-white cursor-pointer" />
                </a>
              </div>
            </div>
          </div>
          <div>
            <h5 className="text-white font-semibold">Map</h5>

            {/* <img src={map} alt="location"  className="  w-[250px] h-[230px] md:w-[300px] pr-[10px] md:pr-[0px] border-none" /> */}
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d892.8045294202968!2d85.3091049492373!3d27.710500985601225!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb18fea24e3ca5%3A0xcd3ae93bcbf7264e!2sRam%20Laxmi%20Store!5e0!3m2!1sen!2snp!4v1731908868461!5m2!1sen!2snp"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="  w-[100%] h-[230px]  pr-[10px] md:pr-[0px] border-none"
            />
          </div>
        </div>
        <div className="h-auto bg-[#6D4828] border-t-[1px] flex justify-center items-center pt-[10px] px-[10px] sm:pt-[10px] font-poppins">
          <p className="text-white ">
            Kathmandu Gold and Silver Dealers' Association. 2013 - 2024 © All
            Rights Reserved.
          </p>
        </div>
      </Container>
    </>
  );
};

export default Footer;
